module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/medical-team-828b4621abfe9492209e2f8372ea5d2c.jpg";